import { defaultIconColor } from '../constants';
import { SVGComponentPropsType } from 'assets/types';

const defaultSize = 24;

export default ({ color = defaultIconColor, size = defaultSize, ...props }: SVGComponentPropsType) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={size}
    height={size}
    viewBox={`0 0 ${defaultSize} ${defaultSize}`}
    {...props}
  >
    <g stroke={color} strokeWidth="2" fill="none" fillRule="evenodd">
      <path d="M7 5h5a1 1 0 0 1 1 1v13h0-7V6a1 1 0 0 1 1-1zM4 19h11" />
      <path
        d="M6 11h7.111a2 2 0 0 1 1.997 1.886l.11 1.936a2.695 2.695 0 0 0 2.691 2.542 1.987 1.987 0 0 0 1.928-2.47L19 11.545h0V8.636L15.861 5.46"
        strokeLinecap="square"
        strokeLinejoin="round"
      />
      <path strokeLinejoin="round" d="M17 7v4h2" />
    </g>
  </svg>
);
